/*@ngInject*/
const ResubmitSubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.resubmit = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/resubmit';
        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('resubmitSubmissionRepository', ResubmitSubmissionRepository);
